import Vue from 'vue'
import Router from 'vue-router'
import exam from '@/views/exam/exam'
import examDetail from '@/views/exam/examDetail'
import examResult from '@/views/exam/examResult'
import school from '@/views/school/'
import play from '@/views/school/play'
import schoolList from '@/views/school/list'
import schoolInfo from '@/views/school/schoolInfo'
import mediaTeamUser from '@/views/school/mediaTeamUser'
import schoolSearch from '@/views/school/search'
import buyedGuide from '@/views/school/buyedGuide'
import Home from '@/views/home/index'
import examLog from '@/views/exam/examLog'
import studyLog from '@/views/school/studyLog'

Vue.use(Router)
export default new Router({
    routes: [
        {
            path: '/',
            redirect:'school',
        },
        {
            path: '/home',
            component: Home,
            partsFlag: 0,
            meta: {
                cname: '我的',
                keepAlive: true, // 不需要缓存
                showLeft: true,
            }
        },
        // {
        //   path:'/academyPreview',
        //   name:'academyPreview',
        //   component:  academyPreview,
        //   cname:'文博学院预览',
        //   partsFlag:0,
        //   meta: {
        //     keepAlive: false, // 不需要缓存
        //     showLeft: false
        //   }
        // },
        // {
        //   path:'/academyPreviewPW',
        //   name:'academyPreviewPW',
        //   component:  academyPreviewPW,
        //   cname:'文博学院PW预览',
        //   partsFlag:0,
        //   meta: {
        //     keepAlive: false, // 不需要缓存
        //     showLeft: false
        //   }
        // },

        // {
        //     name: 'previewTcplay',
        //     path: '/academyPreviewTcplay',
        //     cname: '腾讯视频预览',
        //     component: academyPreviewTcplay,
        //     partsFlag: 0,
        //     meta: {
        //         keepAlive: false, // 不需要缓存
        //         showLeft: false
        //     },
        // },
        {
            name: 'exam',
            path: '/exam',
            component: exam,
            partsFlag: 0,
            meta: {
                cname: '试卷列表',
                keepAlive: true, // 不需要缓存
                showLeft: true
            },
        },
        {
            name: 'examDetail',
            path: '/examDetail',
            component: examDetail,
            partsFlag: 0,
            meta: {
                cname: '考试中...',
                keepAlive: false, // 不需要缓存
                showLeft: true
            },
        },
        {
            name: 'examResult',
            path: '/examResult',
            component: examResult,
            partsFlag: 0,
            meta: {
                cname: '考试结果',
                keepAlive: false, // 不需要缓存
                showLeft: true
            },
        },

        {
            name: 'school',
            path: '/school',
            component: school,
            partsFlag: 0,
            meta: {
                cname: '学习中心',
                keepAlive: true, // 不需要缓存
                showLeft: true
            },
        },
        {
            name: 'studyLog',
            path: '/studyLog',
            component: studyLog,
            partsFlag: 0,
            meta: {
                cname: '学习情况',
                keepAlive: false, // 不需要缓存
                showLeft: true
            },
        },
        {
            name: 'PlayVideo',
            path: '/playvideo',
            component: play,
            partsFlag: 0,
            meta: {
                cname: '课程详情',
                keepAlive: false, // 不需要缓存
                showLeft: true
            },
        },
        {
            name: 'SchoolList',
            path: '/schoollist',
            component: schoolList,
            partsFlag: 0,
            meta: {
                cname: '找课',
                keepAlive: true, // 不需要缓存
                showLeft: true
            },
        },
        {
            name: 'schoolSearch',
            path: '/schoolSearch',
            component: schoolSearch,
            partsFlag: 0,
            meta: {
                cname: '搜索结果',
                keepAlive: true, // 不需要缓存
                showLeft: true
            },
        },
        {
            name: 'schoolInfo',
            path: '/schoolInfo',
            component: schoolInfo,
            partsFlag: 0,
            meta: {
                cname: '我的课程',
                keepAlive: false, // 不需要缓存
                showLeft: true
            },
        },
        {
            name: 'mediaTeamUser',
            path: '/mediaTeamUser',
            component: mediaTeamUser,
            partsFlag: 0,
            meta: {
                cname: '学习小组',
                keepAlive: false, // 不需要缓存
                showLeft: true
            },
        },
        {
            name: 'buyedGuide',
            path: '/buyedGuide',
            component: buyedGuide,
            partsFlag: 0,
            meta: {
                cname: '购买后弹窗',
                keepAlive: false, // 不需要缓存
                showLeft: true
            },
        },
        {
          name: 'examLog',
          path: '/examLog',
          component: examLog,
          partsFlag: 0,
          meta: {
              cname: '考试记录',
              keepAlive: false, // 不需要缓存
              showLeft: true
          },
      },
        // {
        //     name: 'txRedirect',
        //     path: '/txRedirect',
        //     cname: '腾讯课堂中转页面',
        //     component: txRedirect,
        //     partsFlag: 0,
        //     meta: {
        //         keepAlive: false, // 不需要缓存
        //         showLeft: false,
        //         hidden: true
        //     },
        // }
    ]
})
